import Typography from "@mui/material/Typography";
import { CssTextField } from "./CommonStyles";
import AlertDialog from "../Alert";
function CustomerPONumberField({
  custPoNumber,
  handleCustPoNumberChange,
  CheckPoNumber,
  custorPoValidation,
  showPOAlert,
  setShowPOAlert,
}) {
  return (
    <>
      <CssTextField
        type="text"
        fullWidth
        label={
          <span style={{ fontSize: 12 }}>
            Customer PO Number <span style={{ color: "red" }}>*</span>
          </span>
        }
        inputProps={{
          style: { color: "black", fontWeight: "normal" },
          maxLength: 20,
        }}
        value={custPoNumber}
        onChange={handleCustPoNumberChange}
        onBlurCapture={CheckPoNumber}
        variant="standard"
        sx={{ marginLeft: 0 }}
        name="CustomerPONumber"
      />
      {custorPoValidation.invalid && (
        <Typography style={{ color: "red" }} variant="subtitle2">
          {custorPoValidation.msg}
        </Typography>
      )}
      <AlertDialog showPOAlert={showPOAlert} setShowPOAlert={setShowPOAlert} />
    </>
  );
}

export default CustomerPONumberField;
